/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { useLeadUrl } from 'domain/shared/lead';

const LeadsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useLeadUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Leads" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default LeadsBreadcrumbs;
